import React, { useState, useEffect, useRef } from "react";

const Modal = ({
  isOpen,
  title,
  onClose,
  children,
  className,
  compact = false,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const modalRef = useRef(null);

  // Gérer la touche Échap
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // Gérer le clic en dehors du modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        isOpen
      ) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // Empêcher le scroll du body quand le modal est ouvert
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Gestion de la fermeture avec animation
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 200);
  };

  if (!isOpen && !isClosing) {
    return null;
  }

  return (
    <div
      className={`fixed inset-0 z-50 flex w-full rounded-md h-full items-center justify-center bg-black bg-opacity-50 ${compact ? "p-4" : ""} ${
        isClosing ? "animate-fade-out" : "animate-fade-in"
      }`}
    >
      <div
        ref={modalRef}
        className={`${compact ? "bg-white w-full max-h-[90dvh] rounded-2xl shadow-2xl flex flex-col overflow-hidden" : "bg-white w- px-8 py-2 h-full rounded-md shadow-none flex flex-col"} ${
          isClosing ? "animate-scale-out" : "animate-scale-in"
        } ${className || ""}`}
      >
        <div
          className={
            compact
              ? "shrink-0 border-b border-slate-200 px-5 py-4 flex justify-between items-center gap-3"
              : "p-4 flex justify-between items-center"
          }
        >
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <button
            type="button"
            aria-label="Fermer la fenêtre"
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div
          className={
            compact
              ? "min-h-0 overflow-y-auto p-5 text-sm"
              : "p-4 overflow-y-auto flex-1"
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
